document.addEventListener("DOMContentLoaded", function () {
  // Get all section wrappers to ensure proper scoping
  const sectionWrappers = document.querySelectorAll(".tab-content-wrapper");

  sectionWrappers.forEach(function (wrapper, wrapperIndex) {
    // Find tab headers within this specific wrapper
    const tabHeaders = wrapper.querySelectorAll(".tab_div-main");

    tabHeaders.forEach((header) => {
      header.addEventListener("click", function () {
        const tabId = this.getAttribute("data-tabcollapsible-id");

        // Find content div within this specific wrapper
        const contentDiv = wrapper.querySelector(
          `.tab_div-content[data-tabcollapsible-id="${tabId}"]`
        );

        if (contentDiv) {
          // Toggle active state for the clicked header
          this.classList.toggle("active");
          contentDiv.classList.toggle("active");

          // Update display property based on active state
          contentDiv.style.display = contentDiv.classList.contains("active")
            ? "block"
            : "none";

          // Find the section tabs container within this wrapper
          const sectionTabs = this.closest(".right__section-tabs");

          if (sectionTabs) {
            // Find and deactivate all other tabs within this specific section
            const siblingHeaders = sectionTabs.querySelectorAll(
              `.tab_div-main:not([data-tabcollapsible-id="${tabId}"])`
            );

            siblingHeaders.forEach((siblingHeader) => {
              siblingHeader.classList.remove("active");
              const siblingId = siblingHeader.getAttribute(
                "data-tabcollapsible-id"
              );

              // Find sibling content within this specific section
              const siblingContent = sectionTabs.querySelector(
                `.tab_div-content[data-tabcollapsible-id="${siblingId}"]`
              );

              if (siblingContent) {
                siblingContent.classList.remove("active");
                siblingContent.style.display = "none";
              }
            });
          }
        }
      });
    });

    // Optionally activate the first tab in each section by default
    if (tabHeaders.length > 0) {
      const firstHeader = tabHeaders[0];
      const firstTabId = firstHeader.getAttribute("data-tabcollapsible-id");
      const firstContent = wrapper.querySelector(
        `.tab_div-content[data-tabcollapsible-id="${firstTabId}"]`
      );

      if (firstContent) {
        firstHeader.classList.add("active");
        firstContent.classList.add("active");
        firstContent.style.display = "block";
      }
    }
  });
});
